import React, { useState, useEffect } from 'react';
import { OpenFeatureContext } from './OpenFeatureContext';
import FlagsmithProvider from "./providers/flagsmith";
import { OpenFeature, ProviderEvents } from "@openfeature/js-sdk";
import Newsletter from "../lib/Newsletter";
import Api from "../lib/Api";

const OpenFeatureProvider = ({ apiKey, apiHost, children }) => {
  const [openFeatureClient, setOpenFeatureClient] = useState(null);

  useEffect(() => {
    const flagsmithProvider = new FlagsmithProvider(apiKey, apiHost);
    OpenFeature.setProvider(flagsmithProvider);

    const context = { 'targetingKey': Api.getSessionId(), ...Newsletter.getLocalEntry() }

    OpenFeature.addHandler(ProviderEvents.Ready, () => {
      const client = OpenFeature.getClient();

      client.setContext(context);

      setOpenFeatureClient(client);
    })
  }, [apiKey]);

  return (
    <OpenFeatureContext.Provider value={{ openFeatureClient }}>
      {children}
    </OpenFeatureContext.Provider>
  );
};

export default OpenFeatureProvider;
